<template>
  <div>
    <a-card>
      <div style="display: flex;align-items: center">
        <div>
          项目：
          <a-select
            v-model="search.project_name"
            placeholder="请选择代码仓库"
            allow-clear
            show-search
            :filter-option="utils.filterOption"
            style="width: 300px"
            @change="refreshMergeList"
          >
            <a-select-option v-for="(project,index) in gitlabProjects" :key="index" :value="project">
              {{ project }}
            </a-select-option>
          </a-select>
          <!--          <a-input v-model='search.project_name' @change="refreshMergeList" style="width:200px" />-->
        </div>
        <div style="margin-left: 20px">
          仅看建议：
          <a-switch v-model="search.only_suggest" @change="refreshMergeList" />
        </div>
      </div>

    </a-card>
    <a-card title="Merge列表" class="filter-data" style="margin-top: 10px">
      <a-table
        :pagination="pagination"
        :columns="columns"
        size="middle"
        :data-source="tableData"
        row-key="id"
        :loading="loading"
        @change="handlePageChange"
      >
        <span slot="url" slot-scope="text, record">
          <a @click="jumpGitlab(record.url)"> 查看 </a>
        </span>
        <span slot="status" slot-scope="text, record">
          <a-tag v-if="record.status" color="green"> 已打分 </a-tag>
          <a-tag v-else color="orange"> 未打分 </a-tag>
        </span>
        <span slot="action" slot-scope="text, record">
          <a :disabled="record?.suggest_count === 0" @click="onDetail(record)"> {{ record.suggest_count }} </a>
        </span>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import { getMergeList } from '@/api/tools/application';
import { gitlabProjectList } from '@/api/system/service';

export default {
  data() {
    return {
      loading: false,
      search: {
        project_name: '',
        page_number: 1,
        page_size: 10,
        only_suggest: false
      },
      pagination: {
        size: 'large',
        total: 0,
        pageSize: 10, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      gitlabProjects: [],
      columns: [
        {
          title: '项目名',
          key: 'project_name',
          dataIndex: 'project_name',
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          align: 'center',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '建议数',
          dataIndex: 'suggest_count',
          key: 'suggest_count',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: '提交人',
          dataIndex: 'user_name',
          key: 'user_name',
          align: 'center'
        },
        {
          title: '提交时间',
          dataIndex: 'created_time',
          key: 'created_time',
          align: 'center'
        },
        {
          title: 'Merge详情',
          dataIndex: 'url',
          key: 'url',
          align: 'center',
          scopedSlots: { customRender: 'url' }
        }
      ],
      tableData: []
    };
  },
  mounted() {
    this.refreshMergeList();
    this.getGitlabProjects();
  },
  methods: {
    onDetail(record) {
      const routeData = this.$router.resolve({
        name: 'page:tool:crDetail',
        query: {
          id: record.id
        }
      });
      window.open(routeData.href, '_blank');
    },
    jumpGitlab(url) {
      window.open(url, '_blank');
    },
    handlePageChange(pagination) {
      this.pagination = pagination;
      this.refreshMergeList();
    },
    refreshMergeList() {
      this.search.page_number = this.pagination.current | 1;
      this.search.page_size = this.pagination.pageSize;
      getMergeList(this.search)
        .then(res => {
          this.tableData = res.data.items;
          this.pagination.total = res.data.total;
        });
    },
    getGitlabProjects() {
      this.gitlabProjects = [];
      gitlabProjectList({
        page_number: 1,
        page_size: 2000
      })
        .then(res => {
          this.gitlabProjects = [...new Set(res.data.gitlab_projects.map(item => item.name))];
        });
    }

  }
};
</script>

<style scoped lang="less">

</style>
